module.exports = __webpack_public_path__ + "static/media/HigherStudies2.91fce0f0.png";